module.exports = __webpack_public_path__ + "img/frechdax-ev.7738f3b5.png";